module.exports = {"130202001":"学院南路街道","130202002":"友谊街道","130202003":"广场街道","130202004":"永红桥街道","130202005":"小山街道","130202006":"文北街道","130202007":"钱营街道","130202008":"惠民道街道","130202009":"梁家屯路街道","130202102":"稻地镇","130202200":"女织寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130202.json
// module id = 81
// module chunks = 0